<template>

	<!--content -->
	<div class="container">
		<div class="content">
			<section class="find">
				<h2 class="tit_page">비밀번호 찾기</h2>
				<form @submit.prevent="doSearch">
					<div class="find_form">
						<p class="guide_text">회원가입 시에 등록한 아이디, 이름, 휴대전화 정보를 입력해 주세요.</p>
						<div class="form_row">
							<label for="id" class="lab">아이디</label>
							<input type="email" placeholder="이메일 형식" id="id" class="inp" v-model="coEmailId" required="required">
						</div>
						<div class="form_row">
							<label for="name" class="lab">이름</label>
							<input type="text" placeholder="이름" id="name" class="inp" v-model="userName" required="required">
						</div>
						<div class="form_row">
							<label for="phone" class="lab">휴대전화</label>
							<input type="tel" placeholder="휴대전화" id="phone" class="inp" v-model="phoneNo" required="required">
						</div>
					</div>
					<div class="find_button">
						<button type="submit" class="btn btn-lg btn_find">비밀번호 찾기</button>
					</div>
				</form>
			</section>
		</div>
	</div>
	<!--//content -->

</template>

<script>
export default {
	name: "findPasswd",
	data() {

		return {
			coEmailId: "",
			userName: "",
			phoneNo: "",
		}
	},
	created() {

	},
	methods: {


		doSearch(e) {

			e.preventDefault()

			const self = this
			this.$eventBus.$emit("startProgress")
			this.axiosCaller.get(this, this.APIs.CO_ACCOUNT + "/doFindPassword", {
				coEmailId: this.coEmailId,
				userName: this.userName,
				phoneNo: this.phoneNo,
			}, (res) => {
				this.$eventBus.$emit("doneProgress")

				const result = res.data;
				if (result.status === "ok") {
					const coEmailIdArr = result.coEmailId.split("@");
					const emailEnc = self.stringUtils.idFilter(coEmailIdArr[0]) + "@" + coEmailIdArr[1];
					self.swalUtils.fire("비밀번호 초기화", "가입하신 이메일 " + emailEnc + "로 초기화된 이메일이 발송되었습니다.", "success")
						.then(() => {
							self.coEmailId = "";
							self.userName = "";
							self.phoneNo = "";
							location.href = "/";
						});
				} else {
					self.swalUtils.gritter(result.warnLevel == 1 ? "Info" : "Error", result.msg, result.warnLevel == 1 ? "info" : "error", 5000);
				}
			})


		}


	}
}
</script>

<style scoped>

</style>